import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cn from 'classnames';
import styles from './Region.scss';
import { withRouter } from 'react-router-dom';
import { loadProfile } from 'actions/profile';
import { withTranslation } from 'react-i18next';
import AngleDown from 'react-icons/lib/fa/angle-down';
import RegionPopup from './RegionPopup';
import { setPopUp } from 'actions/environment';
import { gaEvent, trackGA } from 'services/ga';
import { getRegionsForDisplay } from 'utils/regionStorage';

class Region extends Component {
  setPopUp = () => {
    const { setPopUp, cities, profile, location, isCurrentBuildingTypeIsCottage } = this.props;

    trackGA(gaEvent.headerButtonsClick({ eventLabel: 'lokaciya', user_id: profile.id }));

    setPopUp(
      <RegionPopup
        cities={cities}
        profile={profile}
        location={location}
        isCurrentBuildingTypeIsCottage={isCurrentBuildingTypeIsCottage}
      />,
      {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
      }
    );
  };

  render() {
    const { className, cities, t } = this.props;

    const { user_regions: userRegions, user_region: userRegion } = getRegionsForDisplay(cities);

    const regionsToDisplay = userRegions && userRegions.length > 0 ? userRegions : [userRegion];

    const getRegionText = () => {
      if (regionsToDisplay.length === 0) {
        return '';
      }

      const countriesMap = regionsToDisplay.reduce((acc, region) => {
        const countryName = region.country_name;
        if (!acc[countryName]) {
          acc[countryName] = [];
        }
        acc[countryName].push(region);
        return acc;
      }, {});

      const countries = Object.keys(countriesMap);

      if (countries.length === 1) {
        const countryName = countries[0];
        const citiesInCountry = countriesMap[countryName];

        const allCitiesInCountry = cities.filter(
          (city) => city.country && city.country.name === countryName
        );
        const selectedCitiesInCountry = citiesInCountry.length;
        const totalCitiesInCountry = allCitiesInCountry.length;

        // Если выбраны все города страны, показываем только название страны
        if (totalCitiesInCountry > 0 && selectedCitiesInCountry === totalCitiesInCountry) {
          // Если в стране только 1 город, показываем "Страна, Город"
          if (totalCitiesInCountry === 1) {
            return `${countryName}, ${citiesInCountry[0].city}`;
          }
          return countryName;
        }

        if (citiesInCountry.length === 1) {
          return `${countryName}, ${citiesInCountry[0].city}`;
        }
        return `${countryName} (${citiesInCountry.length})`;
      }
      const firstTwo = regionsToDisplay.slice(0, 2);
      const firstTwoText = firstTwo.map((r) => `${r.country_name}, ${r.city}`).join(', ');
      const remainingCount = regionsToDisplay.length - 2;
      if (remainingCount > 0) {
        return `${firstTwoText} ${t('components.header.region.andMore')} ${remainingCount}`;
      }
      return firstTwoText;
    };

    const regionText = getRegionText();

    if (cities.length < 2) {
      return (
        <div className={cn(styles.Region, className)}>
          <div className={styles.Text}>
            <span>{regionText}</span>
          </div>
        </div>
      );
    }

    return (
      <div className={cn(styles.Region, className)} onClick={this.setPopUp}>
        <div className={styles.Text}>
          <span>{regionText}</span>
          <AngleDown className={styles.Icon} />
        </div>
      </div>
    );
  }
}

const regionSelector = createSelector(
  (state) => state.building.cities,
  (cities) => ({
    cities,
  })
);

const ConnectedRegion = withTranslation()(
  connect(regionSelector, { setPopUp, loadProfile })(withRouter(Region))
);

export default ConnectedRegion;



// WEBPACK FOOTER //
// ./src/components/Header/Region/Region.js